import { parseUnits, formatUnits, BrowserProvider, Contract } from "ethers";
import { CurrencyAmount, Percent, TradeType } from "@uniswap/sdk-core";
import { Pool, SwapRouter, Trade, Route } from "@uniswap/v3-sdk";

import { ERC20_ABI, SWAP_ROUTER_ADDRESS } from "../web3Utils";
import { getPoolInfo } from "./pool";
import { fetchTokenAddress } from "./utils";
import { connectWallet, subscribeToProviders, getProviders } from "./farm";

export async function createTrade(
  token0,
  token1,
  token0Amount,
  token1Amount,
  poolAddress,
	jsonRpcProvider
) {
  const poolInfo = await getPoolInfo(poolAddress, 
		jsonRpcProvider);
  console.log("poolInfo", poolInfo);

  const pool = new Pool(
    token0,
    token1,
    poolInfo.fee,
    poolInfo.sqrtPriceX96.toString(),
    poolInfo.liquidity.toString(),
    parseInt(poolInfo.tick)
  );

  const swapRoute = new Route([pool], token0, token1);

  const uncheckedTrade = Trade.createUncheckedTrade({
    route: swapRoute,
    inputAmount: CurrencyAmount.fromRawAmount(
      token0,
      // fromReadableAmount(token0Amount, token0?.decimals).toString()
      parseUnits(token0Amount.toString(), token0?.decimals).toString()
    ),
    outputAmount: CurrencyAmount.fromRawAmount(
      token1,
      parseUnits(token1Amount.toString(), token1?.decimals).toString()
      // fromReadableAmount(token1Amount, token1?.decimals).toString()
    ),
    tradeType: TradeType.EXACT_INPUT,
  });

  return uncheckedTrade;
}

export async function executeTrade(
  token0,
  token1,
  token0Amount,
  token1Amount,
  slippageTolerance,
  poolAddress,
	walletAddress,
	jsonRpcProvider,
	signer
) {
  try {
    const trade = await createTrade(
      token0,
      token1,
      token0Amount,
      token1Amount,
      poolAddress,
      jsonRpcProvider,
    );

    if (!walletAddress || !jsonRpcProvider) {
      throw new Error("Cannot execute a trade without a connected wallet");
    }

    const percent = slippageTolerance * 100;
    const options = {
      slippageTolerance: new Percent(percent, 10_000), // 50 bips, or 0.50%
      deadline: Math.floor(Date.now() / 1000) + 60 * 20, // 20 minutes from the current Unix time
      recipient: walletAddress,
    };

    const { calldata, value } = SwapRouter.swapCallParameters([trade], options);

    const fees = await jsonRpcProvider.getFeeData();
    const maxFeePerGas = fees.maxFeePerGas || parseUnits("100", "gwei");
    const maxPriorityFeePerGas =
      fees.maxPriorityFeePerGas || parseUnits("1", "gwei");
    const tx = {
      data: calldata,
      to: SWAP_ROUTER_ADDRESS,
      value: value,
      from: walletAddress,
      maxFeePerGas: maxFeePerGas, 
      maxPriorityFeePerGas: maxPriorityFeePerGas,
    };

    const gasLimit = await jsonRpcProvider.estimateGas(tx);
    tx.gasLimit = gasLimit;
    const res = await signer?.sendTransaction(tx);

    await res.wait();
    return res.hash;
  } catch (error) {
    console.error("Error at ExecuteTrade: ", error);
    return "Failed";
  }
}

export async function getTokenTransferApprovalFromRouter(token, value,         signer,
	jsonRpcProvider) {
  try {
    const token0 = await fetchTokenAddress(token, jsonRpcProvider);

    const tokenContract = new Contract(token0.address, ERC20_ABI, signer);
    const approveTx = await tokenContract.approve(SWAP_ROUTER_ADDRESS, value);
    await approveTx.wait();
    return approveTx.hash;
  } catch (error) {
    console.error(error);
    return "Failed";
  }
}
